<template>
  <b-container>
    <div v-if="loadError" class="text-danger organisation-load-error">{{$t('organisation_load_error')}}
      <b-button class="organisation-load-retry" type="button" :disabled="isBusy" @click="loadData">{{$t('retry')}}</b-button>
    </div>
    <ValidationObserver ref="organisationCreateForm" v-slot="{ invalid }">
    <b-form
        @submit.prevent="onSubmit"
    >
      <fieldset :disabled="saving || isBusy || loadError">
      <validation-provider vid="parentId" v-slot="{ errors }" rules="required" >
      <b-form-group
          label-for="organisation"
          :label="$t('organisation.create.organisation')"
      >
        <b-form-select
            id="organisation"
            v-model="form.parentId"
            placeholder="organisation"
            :options="organisationList"
            value-field="id"
            text-field="name"
        />
        <span class="text-danger">{{ errors[0] }}</span>
      </b-form-group>
      </validation-provider>
      <validation-provider vid="type" v-slot="{ errors }" rules="required" >
      <b-form-group
          label-for="type"
          :label="$t('organisation.create.type')"
      >
        <b-form-select
          id="type"
          :options="organisationTypeList"
          value-field="id"
          text-field="name"
          v-model="form.type"
          :placeholder="$t('organisation.create.type.placeholder')"
        >
        </b-form-select>

        <span class="text-danger">{{ errors[0] }}</span>
      </b-form-group>
      </validation-provider>
      <validation-provider vid="name" v-slot="{ errors }" rules="required|unicodeLength:5,255|userName" >
        <b-form-group
          label-for="organisationName"
          :label="$t('organisation.create.name')"
      >
        <b-input
          id="organisationName"
          v-model="form.name"
          :placeholder="$t('organisation.create.name')"
        >
        </b-input>

        <span class="text-danger">{{ errors[0] }}</span>
      </b-form-group>
      </validation-provider>
    <validation-provider vid="user.type" v-slot="{ errors }" rules="required" >
        <b-form-group
            label-for="userType"
            :label="$t('user.create.type')"
        >
            <b-form-select
                id="userType"
                :options="userTypeList"
                value-field="id"
                text-field="name"
                v-model="form.user.type"
                :placeholder="$t('user.create.type.placeholder')"
            >
            </b-form-select>

            <span class="text-danger">{{ errors[0] }}</span>
        </b-form-group>
    </validation-provider>
    <validation-provider
        vid="user.login" v-slot="{ errors }" rules="required|min:5|max:50|login" >
        <b-form-group
            label-for="userLogin"
            :label="$t('user.create.login')"
        >
            <b-input
                id="userLogin"
                v-model="form.user.login"
                :placeholder="$t('user.create.login.placeholder')"
            >
            </b-input>

            <span class="text-danger">{{ errors[0] }}</span>
        </b-form-group>
    </validation-provider>
    <validation-provider vid="user.password" v-slot="{ errors }" rules="required|min:5|max:255|password" >
        <b-form-group
            label-for="userPassword"
            :label="$t('user.create.password')"
        >
            <b-input
                id="userPassword"
                type="password"
                v-model="form.user.password"
                aria-describedby=""
                :placeholder="$t('user.create.password.placeholder')"
            >
            </b-input>
            <!--        <b-form-text id="password-help-block">-->
            <!--          {{$t('password-help-block')}}-->
            <!--        </b-form-text>-->

            <span class="text-danger">{{ errors[0] }}</span>
        </b-form-group>
    </validation-provider>
    <validation-provider vid="user.name" v-slot="{ errors }" rules="required|unicodeLength:5,255|userName" >
        <b-form-group
            label-for="userName"
            :label="$t('user.create.name')"
        >
            <b-input
                id="userName"
                v-model="form.user.name"
                :placeholder="$t('user.create.name')"
            >
            </b-input>

            <span class="text-danger">{{ errors[0] }}</span>
        </b-form-group>
    </validation-provider>
    <validation-provider vid="user.phone" v-slot="{ errors }" rules="required|phone" >
        <b-form-group
            label-for="userPhone"
            :label="$t('user.create.phone')"
        >
            <b-input
                id="userPhone"
                v-model="form.user.phone"
                :placeholder="$t('user.create.phone')"
            >
            </b-input>

            <span class="text-danger">{{ errors[0] }}</span>
        </b-form-group>
    </validation-provider>
    <validation-provider vid="user.email" v-slot="{ errors }" rules="required|email" >
        <b-form-group
            label-for="userEmail"
            :label="$t('user.create.email')"
        >
            <b-input
                id="userEmail"
                v-model="form.user.email"
                :placeholder="$t('user.create.email')"
            >
            </b-input>

            <span class="text-danger">{{ errors[0] }}</span>
        </b-form-group>
    </validation-provider>
    <div v-if="responseError" class="text-danger organisation-save-error">
      {{$t('saved_error')}} <br>
      {{responseErrorMessage}}
    </div>
      <span v-if="created">
        <div>
          {{$t('saved_successful')}}
        </div>
      </span>
      <b-button
          :disabled="invalid || saving || isBusy || loadError"
          type="submit"
          variant="primary"
      >{{$t('organisation.create')}}</b-button>

      </fieldset>
    </b-form>
    </ValidationObserver>
  </b-container>
</template>

<script>
import axios from "axios";
import { saveForm } from "../../utils/SaveForm";
import { isOrganisationCreateValid } from "../../utils/OrganisationForm";
import { isRouteId } from "../../utils/FormValidation";
import { REQUEST_TIMEOUT_MS } from "../../utils/RequestGuard";

export default {
  name: "Create",
  data() {
    return {
        isBusy: true, loadError: false, saving: false, disposed: false, requestVersion: 0, readVersion: 0,
        organisationList: [],
        organisationTypeList: [],
        userTypeList: [
            {id: 'admin', name: 'admin'},
            {id: 'user', name: 'user'}
        ],
        form: {
            parentId: null,
            type: null,
            name: null,
            user: {
                type: null,
                login: null,
                password: null,
                name: null,
                phone: null,
                email: null,
            }
        },
        responseError: false,
        responseErrorMessage: null,
        created: false
    }
  },
  methods: {
    onSubmit() {
      if (this.isBusy || this.loadError) return;
      return saveForm(this, { method: 'put', url: 'api/v1/organisations/with-user', payload: this.form,
        observer: 'organisationCreateForm', success: 'created', event: 'onCreated',
        fields: ['parentId', 'type', 'name', 'user.type', 'user.login', 'user.password', 'user.name', 'user.phone', 'user.email'],
        fieldAliases: { login: 'user.login' },
        validPayload: value => isOrganisationCreateValid(value, this.organisationList.map(item => item.id), this.organisationTypeList.map(item => item.id)),
      });
    },
    async loadData() {
      if (this.disposed) return;
      const request = ++this.readVersion;
      this.isBusy = true; this.loadError = false;
      try {
        const [parents, types] = await Promise.all([
          axios.get('api/v1/users/organisations', { timeout: REQUEST_TIMEOUT_MS }),
          axios.get('api/v1/users/oranisationTypes', { timeout: REQUEST_TIMEOUT_MS }),
        ]);
        if (this.disposed || request !== this.readVersion) return;
        if (!Array.isArray(parents.data?.rows) || !Array.isArray(types.data?.rows)) throw new Error('Invalid organisation dictionaries');
        this.organisationList = parents.data.rows.filter(item => isRouteId(item?.id));
        this.organisationTypeList = types.data.rows.filter(item => Number.isInteger(item?.id) && item.id >= 2 && item.id <= 4);
      } catch (error) {
        if (!this.disposed && request === this.readVersion && error.response?.status !== 401) this.loadError = true;
      } finally { if (!this.disposed && request === this.readVersion) this.isBusy = false; }
    },
  },
  mounted() { this.loadData(); },
  beforeDestroy() { this.disposed = true; this.requestVersion++; this.readVersion++; },
}
</script>

<style scoped>

</style>